import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const dishes = [
  {
    id: "risotto",
    name: "Risotto in Cagnone",
    tag: "Primo",
    desc: "Riso Sant'Andrea mantecato con burro dorato e formaggi tipici locali: il piatto che profuma di alpeggio.",
    img: "/images/risotto.jpg",
    real: true,
  },
  {
    id: "agnolotti",
    name: "Agnolotti al Sugo d'Arrosto",
    tag: "Primo",
    desc: "Pasta fresca tirata a mano, ripiena di carni stufate e avvolta nella riduzione d'arrosto della tradizione.",
    img: "/images/agnolotti.jpg",
    real: true,
  },
  {
    id: "torcetti",
    name: "Torcetti alla crema di Ratafià",
    tag: "Dolce",
    desc: "I fragranti torcetti di Biella incontrano una crema vellutata al Ratafià artigianale di Andorno.",
    img: "/images/torcetti.jpg",
    real: true,
  },
  {
    id: "panissa",
    name: "Panissa",
    tag: "Primo",
    desc: "Riso cotto nel vino rosso con salame, fagioli e lardo, mantecato con burro e parmigiano: la Vercellese che abbraccia il Biellese.",
    img: "/images/panissa.jpg",
    real: true,
  },
  {
    id: "bonet",
    name: "Bonet",
    tag: "Dolce",
    desc: "Il budino piemontese per eccellenza: cioccolato e amaretti, servito con il suo caramello lucido.",
    img: "/images/bonet.jpg",
    real: true,
  },
];

const Piatti = () => (
  <section id="piatti" className="py-24 lg:py-36 bg-[#12100E] text-[#F5F3EF]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-16 lg:mb-24">
        <Reveal>
          <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#D99B26] font-medium">Pietanze & dolci tipici</span>
          <h2 className="mt-6 font-serif-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight" data-testid="piatti-title">
            I piatti che ci <em className="text-[#D99B26]">raccontano.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-xs text-sm leading-relaxed text-[#F5F3EF]/60 font-light">
            Cucina di territorio: pochi gesti, ingredienti biellesi, ricette che non hanno bisogno di traduzioni.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {dishes.map((d, i) => (
          <Reveal key={d.id} delay={i * 0.12} className={i === 1 || i === 4 ? "md:mt-14" : ""}>
            <motion.article
              whileHover="hover"
              className="group border border-[#F5F3EF]/10 bg-[#F5F3EF]/[0.03] p-4 pb-8 transition-colors duration-500 hover:border-[#D99B26]/40"
              data-testid={`dish-card-${d.id}`}
            >
              <div className="frame-clip overflow-hidden aspect-[4/5] relative">
                <motion.img
                  src={d.img}
                  alt={d.name}
                  loading="lazy"
                  variants={{ hover: { scale: 1.07 } }}
                  transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                  className={`${d.real ? "" : "img-duotone "}h-full w-full object-cover`}
                />
                <span className="absolute top-3 left-3 font-mono-accent text-[10px] uppercase tracking-[0.25em] bg-[#12100E]/80 backdrop-blur px-3 py-1.5 text-[#D99B26]">
                  {d.tag}
                </span>
              </div>
              <div className="mt-6 px-2">
                <span className="font-mono-accent text-xs text-[#D99B26]">0{i + 1}</span>
                <h3 className="mt-2 font-serif-display text-xl sm:text-2xl font-medium leading-snug">{d.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#F5F3EF]/60 font-light">{d.desc}</p>
              </div>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Piatti;
